import { requestRecaptcha as request } from '@/config/ConfigRequest';
import ENDPOINT from '@/config/endpoint';

function getBanners() {
  return request({
    url: ENDPOINT.BANNERS,
    method: 'get',
  });
}

export default {
  getBanners,
};
